
export default callback => (firstLoad, propsMatch = true) => {
  if (firstLoad) {
    callback();
  }
  return { firstLoad: !propsMatch };
};



// WEBPACK FOOTER //
// ./shared/lib/handle-first-component-load/index.js